class MFRStickyElements {
  constructor( i, e ) {
      this.$index = i
      this.$element = $( e )

      this.selectors = {
        stickyWrapper: '.mfr-sticky-wrapper',
        stickyElement: '.mfr-sticky-element'
      }

      this.init()
  }

  init() {
    this.$stickyWrapper = this.$element.find(this.selectors.stickyWrapper)
    this.$stickyElement = this.$element.find(this.selectors.stickyElement)

    this.initSticky()
  }

  initSticky() {
    const endTrigger = this.$stickyWrapper.outerHeight() - this.$stickyElement.outerHeight()

    ScrollTrigger.create({
      trigger: this.$stickyElement,
      start: `top top+=${$('header.header').height()}`,
      end: `+=${endTrigger}`,
      pin: true, // pin the element
      pinSpacing: false,
    })
  }
}